import { useMemo } from 'react';

export const useScheduled = (time?: number) => {
  return useMemo(() => {
    return time && time * 1000 - Date.now() > 10 * 1000
  }, [ time ]);
}
